import { createAction, props } from '@ngrx/store';
import { ProfileDataDto, RawFormDocument } from 'src/app/data/dtos';
import { GetDocumentResponseDto } from 'src/app/data/dtos/get-document-response.dto';

export const getProfileData = createAction('[Profile] getProfileData');
export const getProfileDataSuccess = createAction(
  '[Profile] getProfileData success',
  props<ProfileDataDto>(),
);
export const getProfileDataFromHomeSuccess = createAction(
  '[Profile] getProfileDataFromHomeSuccess success',
  props<ProfileDataDto>(),
);
export const getProfileDataSuccessAlreadyLoaded = createAction(
  '[Profile] getProfileDataSuccessAlreadyLoaded success',
  props<ProfileDataDto>(),
);
export const updateProfileDataUserInformation = createAction(
  '[Profile] updateProfileDataUserInformation',
  props<ProfileDataDto>(),
);
export const updateProfileDocuments = createAction(
  '[Profile] updateProfileDocuments',
  props<ProfileDataDto>(),
);
export const updateProfileDataExperiences = createAction(
  '[Profile] updateProfileDataExperiences',
  props<ProfileDataDto>(),
);

export const updateProfileDataHobbies = createAction(
  '[Profile] updateProfileDataHobbies',
  props<ProfileDataDto>(),
);
export const getProfileDataFailure = createAction(
  '[Profile] getProfileData failure',
  props<{ error: string }>(),
);
export const updateDocuments = createAction(
  '[Profile] updateDocument',
  props<{document: RawFormDocument}>(),
);
export const removeDocument = createAction(
  '[Profile] removeDocument',
  props<{documentType: string}>(),
);

export const resetProfileData = createAction('[Profile] resetProfileData');

